/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserBatchResponse {
    getFixupPrototypeFunction() { return UserBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<UserBatchResponse>): UserBatchResponse {
        let obj = Object.assign(new UserBatchResponse(), model);
        UserBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserBatchResponse>): UserBatchResponse {
        if (!model) return null;
        return UserBatchResponse.newInstance(<UserBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserBatchResponse) {
        if (!obj) return;

        models.UserBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserBatchResponse): boolean {
        Object.setPrototypeOf(obj, UserBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.UserDescribeResponse.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from user ID to user response
     */
    results: { [key: string]: models.UserDescribeResponse; };

}
